module.exports = __webpack_public_path__ + "media/img/clients/client9-08f1b1510b52338429590f43e703e04e.svg";